export const applicationTheme = {
  colors: {
    white: "#FFF",
    black: "#000",

    green100: "#9DD49C",
    green200: "#7DC67B",
    green300: "#5DB85B",
    green400: "#53A551",
    green450: "#28A745",
    green500: "#41803F",
    green600: "#02B102",

    gray000: "#F6F7F9",
    gray100: "#CACACA",
    gray200: "#9E9E9E",
    gray300: "#747474",
    gray400: "#4C4C4D",
    gray450: "#495057",
    gray800: "#282828",

    red400: "#D9534f",
    red500: "#D32D41",

    yellow300: "#F4DC00",
    yellow400: "#C9A139",

    blue100: "#BFE5F4",
    blue300: "#5BC0DE",
    blue400: "#46B8DA",
    blue500: "#0000FF",
    blue600: "#00008B",

    purple400: "#9c27b0",
    purple500: "#800080",

    orange300: "#FFBC3C",
    orange400: "#FFA834",
    orange500: "#FFB400",

    approvalBG: "#5CB85C",
    approvalBorder: "#4CAE4C",
    alertBG: "#FFBC3C",
    alertBorder: "#FFB400",
    rejectBG: "#D9534F",
    rejectBorder: "#D43F3A",
    notApplicableBG: "#5BC0DE",
    notApplicableBorder: "#46B8DA",

    navy900: "#000722",
    border: "#E4E7EC",
    surface: "#FFFFFF",
    textStrong: "#101828",
    textMuted: "#5D6B82",
  },
  // Cor de destaque e fundo suave de cada indicador (contraste AA no texto).
  tones: {
    indigo: { fg: "#3F51B5", bg: "#ECEEF9" },
    purple: { fg: "#673AB7", bg: "#F0EBF8" },
    teal: { fg: "#00796B", bg: "#E0F2F1" },
    green: { fg: "#1E7E34", bg: "#E7F4EA" },
    red: { fg: "#C62828", bg: "#FDECEC" },
    orange: { fg: "#B45309", bg: "#FFF4E5" },
  },
  shadows: {
    sm: "0 1px 2px rgba(16, 24, 40, 0.06), 0 1px 3px rgba(16, 24, 40, 0.10)",
    md: "0 4px 8px -2px rgba(16, 24, 40, 0.10), 0 2px 4px -2px rgba(16, 24, 40, 0.06)",
  },
  fonts: {
    default: "Roboto, sans-serif",
  },
  fontSizes: {
    "4xs": "0.375rem",
    "3xs": "0.563rem",
    "2xs": "0.625rem",
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "4xl": "2rem",
    "5xl": "2.25rem",
    "6xl": "3rem",
    "7xl": "4rem",
    "8xl": "4.5rem",
    "9xl": "6rem",
  },
  fontWeights: {
    regular: "400",
    medium: "500",
    semi: "600",
    bold: "700",
  },
  lineHeights: {
    shorter: "125%",
    short: "140%",
    base: "160%",
    tall: "180%",
  },
  radii: {
    px: "1px",
    xs: "4px",
    sm: "6px",
    md: "8px",
    lg: "16px",
    card: "12px",
    full: "99999px",
  },
  space: {
    1: "0.25rem",
    2: "0.5rem",
    3: "0.75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    10: "2.5rem",
    12: "3rem",
    16: "4rem",
    20: "5rem",
    21: "6rem",
    22: "7rem",
    40: "10rem",
    64: "16rem",
    80: "20rem",
  },
  zIndex: {
    static: -1,
    normal: 0,
    tooltip: 4,
    dropdown: 20,
    menu: 100,
    overlay: 150,
    modal: 200,
  },
};
